import { PreviewCart } from "@app/scripts/components/cart/preview-cart";
import { debounce } from "@app/scripts/utils/debounce";

class PreviewCartClose extends PreviewCart {
    constructor() {
        super();
        
        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener('click', this.closePreviewCart.bind(this));
    }
}

class PreviewCartRemove extends PreviewCart {
    constructor() {
        super();

        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener("click", (event) => {
            const bundleProductTitle = this.getAttribute("data-bundle-product-title") || "" as string;
            const bundleId = this.getAttribute("data-bundle-id") || "" as string;
            const itemKey = bundleId ? this.getAttribute("data-variant-id") : this.getAttribute("data-item-key") as string;

            const bundleProducts = this.findBundleProducts(bundleProductTitle, itemKey, bundleId) || [] as Array<any>;
            
            super.removeItem(itemKey, bundleProducts);
        })
    }

    findBundleProducts(targetBundleProductTitle: string, targetKey:string, targetBundleId: string) {      
        let bundleProducts = [] as Array<any>
        const removeButtons = document.querySelectorAll("preview-cart-remove");

        if (targetBundleId) {
            removeButtons.forEach((button) => {
                const bundleProductTitle = button.getAttribute("data-bundle-product-title");
                const bundleId = button.getAttribute("data-bundle-id");
                const quantity = button.getAttribute("data-quantity");
    
                if (bundleId == targetBundleId) {
                    if(bundleProductTitle == targetBundleProductTitle) {
                        const itemKey = button.getAttribute("data-variant-id") as string;
    
                        if (itemKey !== targetKey) {
                            if (!bundleProducts.some(product => product.id === itemKey)) {
                                bundleProducts.push({ 
                                    id: itemKey,
                                    quantity: quantity
                                });
                            }
                        }
                    }
                }
            })
        }
      
        return bundleProducts
    }
}

class PreviewCartBundleRemove extends PreviewCart {
    constructor() {
        super();

        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener("click", (event) => {
            const keyElems = this.parentNode.querySelectorAll("[data-item-key][data-in-bundle");
            const keys = {};

            if (keyElems?.length) {
                for (let i = 0; i < keyElems.length; i += 1) {
                    keys[`${keyElems[i]?.dataset?.itemKey}`] = 0
                }
                super.removeBundle(keys);
            }
        })
    }
}

class PreviewCartUpdate extends PreviewCart {
    private debounceWait: number;
    private changeEvent: Event;
    private inputElement: HTMLInputElement | null;
    private oldQuantity: number;

    constructor() {
        super();
        this.debounceWait = 200;
        this.changeEvent = new Event('change', { bubbles: true });
        this.inputElement = this.querySelector('input');
        this.oldQuantity = Number(this.inputElement?.value);
        this.bindEvents();
    }

    bindEvents() {
        const minusButton = this.querySelector('.minus');
        const plusButton = this.querySelector('.plus');
     
        minusButton?.addEventListener('click', this.onMinusButtonClick.bind(this));
        plusButton?.addEventListener('click', this.onPlusButtonClick.bind(this));

        this.inputElement?.addEventListener('change', debounce((event: Event) => {
            this.onInputChange();
        }, this.debounceWait))
    }

    onMinusButtonClick(event: Event) {
        const previousValue = this.inputElement?.value;
        this.inputElement?.stepDown();

        if(previousValue != this.inputElement?.value) {
            this.inputElement?.dispatchEvent(this.changeEvent);
        }
    }

    onPlusButtonClick(event: Event) {
        this.inputElement?.stepUp();
        this.inputElement?.dispatchEvent(this.changeEvent);
    }

    onInputChange() {
        const newQuantity = Number(this.inputElement?.value) as number;
        const itemKey = this.getAttribute("data-item-key") as string;
        const variantId = this.getAttribute("data-variant-id") as string;
        const inBundle = this.getAttribute("data-in-bundle") as string;
        super.updateItem(itemKey, newQuantity, this.oldQuantity, inBundle === 'true' ? variantId : '' );
    }
}

class CartUpsellAtc extends PreviewCart {
    private debounceWait: number;

    constructor() {
        super();
        this.debounceWait = 200;
        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener('click', debounce((event: Event) => {
            const variantId = this.getAttribute("data-variant") as string;
            super.addUpsellItem(variantId, 1);
        }, this.debounceWait))
    }
}


customElements.define("preview-cart-close", PreviewCartClose);
customElements.define("preview-cart-remove", PreviewCartRemove);
customElements.define("preview-cart-qty", PreviewCartUpdate);
customElements.define("preview-cart-bundle-remove", PreviewCartBundleRemove);
customElements.define("cart-upsell-atc", CartUpsellAtc);


